export default {"src":"/_next/static/media/Google_2015_logo.0996f094.svg","height":92,"width":272,"blurWidth":0,"blurHeight":0};